<template>
  <div>
    <div ref="svgContainer" @mousemove="onMouseMove" @click="onChange">
      <as-dialogo
        :title="'Stand - ' + stand.codigo"
        max-width="400px"
        semPadding
        hideDivider
        ref="editar"
      >
        <v-form ref="form">
          <v-row dense class="pa-4">
            <v-col cols="12">
              <v-text-field
                label="Nome"
                ref="nome"
                v-model="stand.nome"
                maxlength="18"
                @keydown.prevent.enter="salvar"
                @input="(value) => (stand.nome = value.toUpperCase())"
                autofocus
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
        <div slot="botoes">
          <v-btn
            depressed
            class="mr-4"
            @click="$refs.editar.fechar()"
            :disabled="loading"
            >Cancelar</v-btn
          >
          <v-btn depressed color="primary" @click="salvar" :loading="loading"
            >Salvar</v-btn
          >
        </div>
      </as-dialogo>
    </div>
    <v-card class="mx-4" v-if="dados.rodada">
      <v-row dense>
        <v-col dense cols="9">
          <v-card-subtitle class="pb-0"
            ><b>{{ dados.rodada.nome }}</b></v-card-subtitle
          >
          <v-card-subtitle class="py-0">{{
            dados.rodada.local
          }}</v-card-subtitle>
          <v-card-subtitle class="pt-0"
            ><small
              >{{ moment(dados.rodada.data_inicio).format("DD/MM/YYYY") }} a
              {{ moment(dados.rodada.data_fim).format("DD/MM/YYYY") }}</small
            ></v-card-subtitle
          >
        </v-col>
        <v-col dense cols="3">
          <v-flex style="text-align:end" class="pr-4 pt-4">
            <v-btn
              fab
              :href="
                `whatsapp://send?text=https://${
                  isDev ? 'dev' : 'www'
                }.namoda.com.vc?mapa-stands=${rodadaId}`
              "
              link
              text
              small
            >
              <v-img src="@/assets/whatsapp.svg" height="32" width="32" />
            </v-btn>
            <br />
            <span style="font-size:8px">Compartilhar</span>
          </v-flex>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import SvgMapa from "../assets/rota-do-mar-clube.svg";
import ServiceRodadas from "@/services/rodadas.js";
import moment from "moment";

export default {
  name: "Impressoes",
  data() {
    return {
      loading: false,
      lastTarget: null,
      edit: 0,
      nome: "",
      rodadaId: null,
      dados: {},
      stand: {
        nome: "",
        codigo: "",
      },
      moment,
    };
  },

  mounted() {
    this.rodadaId = this.$route.params.rodada;
    ServiceRodadas.listarStandsMapa(this.rodadaId).then(({ data }) => {
      this.dados = data;
      this.carregarSvg();
    });
  },

  computed: {
    isDev() {
      return (
        !["https://namoda.com.vc", "https://www.namoda.com.vc"].includes(
          window.location.origin
        ) && !window.localStorage.getItem("devOff")
      );
    },
  },

  methods: {
    carregarSvg() {
      fetch(SvgMapa)
        .then((res) => res.text())
        .then((res) => {
          this.$refs.svgContainer.innerHTML = res;
          this.$refs.svgContainer.firstChild.id = "svgMapa";
          this.processStands(this.$refs.svgContainer.firstChild);
        })
        .catch((err) => {
          this.$eventbus.erro("Opss... Algo deu errado");
        });
    },

    salvar() {
      this.loading = true;

      const stand = {
        codigo: this.stand.codigo,
        nome: this.stand.nome,
        valor: 0,
      };

      ServiceRodadas.salvarStandMapa(this.rodadaId, stand)
        .then(() => {
          const standOk = this.dados.stands.find(
            (i) => i.codigo == stand.codigo
          );

          if (standOk) {
            this.dados.stands = this.dados.stands.map((i) =>
              i.codigo === stand.codigo ? stand : i
            );
          } else {
            this.dados.stands.push(stand);
          }

          this.$refs.editar.fechar();
          this.$eventbus.notificar("Stand salvo com sucesso");
          this.loading = false;
          this.carregarSvg();
        })
        .catch(() => {
          this.loading = false;
          this.$eventbus.erro("Não foi possível salvar o nome do stand");
        });
    },
    onMouseMove(event) {
      if (this.lastTarget !== event.target.parentElement) {
        const el = event.target.parentElement;
        if (el.nodeName === "g") {
          this.lastTarget = el;
          const svg = el.parentElement;
          svg.insertBefore(this.lastTarget, svg.lastChild.nextSibling);
        }
      }
    },
    onChange(event) {
      if (this.$auth.user.tipo !== "administrador") return;
      if (this.edit === 0) {
        this.edit = 1;
        setTimeout(() => (this.edit = 0), 400);
      } else if (this.edit === 1) {
        this.edit = 0;
        const standCodigo = event.srcElement.id?.toUpperCase();
        const standObj = this.dados.stands.find(
          (stand) => stand.codigo?.toUpperCase() === standCodigo
        );
        this.stand = standObj || { nome: "", codigo: standCodigo };
        this.$refs.editar.abrir();
      }
    },
    processStands(svg) {
      svg.querySelectorAll("[id]").forEach((rect) => {
        const w = rect.width.baseVal.value;
        const h = rect.height.baseVal.value;

        const oldContent = rect.outerHTML;

        const standObj = this.dados.stands.find(
          (stand) => stand.codigo?.toUpperCase() === rect.id?.toUpperCase()
        );
        let lineArray = ["", ""];
        if (standObj) {
          const regexp = /(?![^\n]{1,9}$)([^\n]{1,9})\s/g;
          lineArray = standObj.nome.replace(regexp, "$1`").split("`");
        }

        if (h > w) {
          if (standObj && standObj.nome.trim()) {
            rect.outerHTML = `<g style="filter:contrast(2.5)">${oldContent}<text x="${
              rect.x.baseVal.value
            }" y="${
              rect.y.baseVal.value
            }" dominant-baseline="end" text-anchor="end" dy="${6}" dx="${w -
              2}" font-size="5" font-weight="600">${rect.id.toUpperCase()}</text> <text x="${
              rect.x.baseVal.value
            }" y="${rect.y.baseVal.value +
              h}" dominant-baseline="end" text-anchor="start" dy="0" dx="4" font-size="5" transform="rotate(-90)">${
              lineArray[0]
            }</text>
        <text x="${rect.x.baseVal.value}" y="${rect.y.baseVal.value +
              h}" dominant-baseline="end" text-anchor="start" dy="0" dx="10" font-size="5" transform="rotate(-90)">${lineArray[1] ||
              ""}</text></g>`;
          } else {
            rect.outerHTML = `<g fill-opacity="0.6">${oldContent}<text x="${
              rect.x.baseVal.value
            }" y="${
              rect.y.baseVal.value
            }" dominant-baseline="middle" text-anchor="middle" dy="${h /
              2}" dx="${w /
              2}" font-size="8" font-weight="600">${rect.id.toUpperCase()}</text></g>`;
          }
        } else {
          if (standObj && standObj.nome.trim()) {
            rect.outerHTML = `<g style="filter:contrast(2.5)">${oldContent}<text x="${
              rect.x.baseVal.value
            }" y="${
              rect.y.baseVal.value
            }" dominant-baseline="start" text-anchor="end" dy="${h -
              2}" dx="${w -
              2}" font-size="6" font-weight="600">${rect.id.toUpperCase()}</text><text x="${
              rect.x.baseVal.value
            }" y="${
              rect.y.baseVal.value
            }" dominant-baseline="end" text-anchor="start" dy="6" dx="2" font-size="5">${
              lineArray[0]
            }</text>
        <text x="${rect.x.baseVal.value}" y="${
              rect.y.baseVal.value
            }" dominant-baseline="end" text-anchor="start" dy="12" dx="2" font-size="5">${lineArray[1] ||
              ""}</text>
              </g>`;
          } else {
            rect.outerHTML = `<g fill-opacity="0.6">${oldContent}<text x="${
              rect.x.baseVal.value
            }" y="${
              rect.y.baseVal.value
            }" dominant-baseline="middle" text-anchor="middle" dy="${h /
              2}" dx="${w /
              2}" font-size="8" font-weight="600">${rect.id.toUpperCase()}</text></g>`;
          }
        }
      });
    },
  },
};
</script>

<style>
#svgMapa * {
  transition: all 0.5s ease;
}

#svgMapa {
  font-size: 3px;
  width: 100%;
  height: 100%;
  padding: 16px;
}

#svgMapa text {
  pointer-events: none;
  user-select: none;
  transform-box: fill-box;
  transform-origin: 0% 50%;
}

#svgMapa g {
  transform-box: fill-box;
  transform-origin: center;
}

#svgMapa + rect {
  pointer-events: none;
  fill-opacity: 0.5;
}

#svgMapa rect {
  stroke: white;
  stroke-width: 0.2px;
}

#svgMapa g:hover {
  fill-opacity: 1;
  transform: scale(3);
}
</style>
